import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const CalendarWidget = () => {
    const navigate = useNavigate();
    const [events, setEvents] = useState([]);
    const [currentDate] = useState(new Date());

    useEffect(() => {
        const fetchEvents = async () => {
            const res = await fetch('/api/calendar/events', { credentials: 'include' });
            if (res.ok) {
                const data = await res.json();
                setEvents(data);
            }
        };
        fetchEvents();
    }, []);

    const getDaysInMonth = (year, month) => new Date(year, month + 1, 0).getDate();
    const getFirstDayOfMonth = (year, month) => new Date(year, month, 1).getDay();

    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const daysInMonth = getDaysInMonth(year, month);
    const firstDay = getFirstDayOfMonth(year, month);
    const days = [];

    // Simple visual calendar
    for (let i = 0; i < firstDay; i++) days.push(<div key={`empty-${i}`} className="mini-day empty"></div>);
    for (let d = 1; d <= daysInMonth; d++) {
        const date = new Date(year, month, d);
        const dateStr = date.toISOString().split('T')[0];
        const dayEvents = events.filter(e => new Date(e.start_date).toISOString().split('T')[0] === dateStr);
        const isToday = new Date().toDateString() === date.toDateString();

        days.push(
            <div key={d} className={`mini-day ${isToday ? 'today' : ''} ${dayEvents.length > 0 ? 'has-events' : ''}`} title={`${dayEvents.length} compromissos`}>
                {d}
                {dayEvents.length > 0 && (
                    <div className="mini-tooltip">
                        <strong>{dayEvents.length} Itens:</strong>
                        {dayEvents.slice(0, 2).map((e, i) => <div key={i}>• {e.title}</div>)}
                    </div>
                )}
            </div>
        );
    }

    const todayEvents = events.filter(e => {
        const d = new Date(e.start_date);
        return d.toDateString() === new Date().toDateString();
    });

    return (
        <div className="widget-classic calendar-widget-classic">
            <div className="widget-header" onClick={() => navigate('/calendario')} style={{ cursor: 'pointer' }}>
                <span>Calendário Interativo</span>
                <span className="icon">📅</span>
            </div>
            <div className="widget-body mini-calendar-body">
                <div className="mini-calendar-grid">
                    {["D", "S", "T", "Q", "Q", "S", "S"].map(d => <div key={d} className="mini-day header">{d}</div>)}
                    {days}
                </div>
                <div className="mini-events-list">
                    <strong>Hoje ({new Date().toLocaleDateString('pt-BR')}) ({todayEvents.length}):</strong>
                    {todayEvents.length > 0 ? todayEvents.map(e => (
                        <div key={e.id} className="mini-event-item">
                            • {e.title}
                        </div>
                    )) : <p className="empty-msg">Nenhum para hoje.</p>}
                </div>
            </div>
        </div>
    );
};

export default CalendarWidget;
